import React, { ReactNode } from 'react';

import './full-screen-layout.css';

interface Props {
    children: ReactNode;
}

// This keeps the content area for the {children} from shrinking past the point where the layout
// would break.
const contentMinWidth = 1150;

export const FullScreenLayout = ({ children }: Props): JSX.Element => (
    <div className="full-screen-layout h-full w-full bg-no-repeat bg-fixed flex justify-start fixed top-0">
        <div
            className="pt-24 flex justify-center flex-grow overflow-auto"
            style={{
                minWidth: contentMinWidth,
            }}
        >
            {children}
        </div>
    </div>
);
